// const JS_HOOK_INPUT_COUNTER = `[js-hook-input-counter]`;
const JS_HOOK_INPUT_FIELD = `[js-hook-input-counter-input]`;
const JS_HOOK_COUNTER = `[js-hook-input-counter-counter]`;
const JS_HOOK_ERROR_MESSAGE = `[js-hook-input-counter-error-message]`;
const ERROR_CLASS = 'is-counter-error';

/**
 * InputCounter component.
 * @module components/input-counter
 */
class InputCounter {
  constructor(element) {
    this.element = element;
    this.input = this.element.querySelector(JS_HOOK_INPUT_FIELD);
    this.counter = this.element.querySelector(JS_HOOK_COUNTER);
    this.errorMessageElement = this.element.querySelector(JS_HOOK_ERROR_MESSAGE);
    this.hasError = false;

    const { maxLength, errorMessage } = this.element.dataset
    this.maxLength = parseInt(maxLength, 10) || 0;
    this.errorMessage = errorMessage || '';

    this.initEvents();
    this.bindChangeEvents()
  }

  initEvents() {
    this.updateCounter();
  }

  /**
   * Bind change events to input field
   */
  bindChangeEvents() {
    this.input.addEventListener('input', () => {
      this.updateCounter();
    });

    this.input.addEventListener('input:updateCounter', () => {
      this.updateCounter();
    });

    this.input.addEventListener('keyup', () => {
      this.showMaxLengthError();
    });
  }

  /**
   * Update counter
   */
  updateCounter() {
    const currentLength = this.input.value.length;
    this.counter.innerHTML = `${currentLength}/${this.maxLength}`;
  }

  /**
   * Show max length error
   */
  showMaxLengthError() {
    const currentLength = this.input.value.length;
    if (this.errorMessageElement) {
      if (currentLength >= this.maxLength) {
        if (this.hasError) {
            this.element.classList.add(ERROR_CLASS);
        }
        this.hasError = true;
      } else {
          this.element.classList.remove(ERROR_CLASS);
          this.hasError = false;
      }
    }
  }
}

export default InputCounter
